// extracted by mini-css-extract-plugin
export default {"moreButton":"OPsM9","openButton":"p3qE6","arrow":"MS5Dp","arrowUp":"VCntO","actionText":"aw7Te","preLabel":"INLSV"};